// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;For my kindred and companions&#146; sake,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;I will pray that peace be with you.<br> </p> </div></div>";
// Exports
module.exports = code;